/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */
 
 <template>
    <div class="confirmation-main-grid">

        <div class="grid-col">
            <div class="info-card">
                <h4>Información del contacto</h4>
                <div class="info-item"><label>Código del proyecto:</label><span>{{ formData.codigo_proyecto || 'N/A'
                        }}</span></div>
                <div class="info-item"><label>Contacto:</label><span>{{ formData.nombre }} {{ formData.apellidoPaterno
                        }} {{ formData.apellidoMaterno }}</span></div>
                <div class="info-item"><label>Localidad:</label><span>{{ formData.localidadProyecto ||
                    formData.localidad }}</span></div>
                <div class="info-item"><label>Fuente:</label><span>{{ formData.fuente || 'Directo' }}</span></div>
                <div class="info-item"><label>Teléfono:</label><span>{{ formData.telefono }}</span></div>
                <div class="info-item"><label>Correo electrónico:</label><span>{{ formData.email }}</span></div>
            </div>

            <div class="savings-card">
                <h4>Sin paneles</h4>
                <div class="savings-item">
                    <label>Pago mensual promedio a CFE</label>
                    <span>{{ formatMoney(averagePago) }}</span>
                </div>
            </div>

            <div class="info-card tir-card">
                <h4>TIR a 25 años</h4>
                <label>Tasa interna de retorno a 25 años</label>
                <span>{{ tirRoi.tir }}%</span>
            </div>
        </div>

        <div class="grid-col">
            <div class="info-card">
                <h4>Información del consumo</h4>
                <div class="info-item"><label>Nombre Proyecto:</label><span>{{ formData.nombreProyecto }}</span></div>
                <div class="info-item"><label>Tarifa:</label><span>{{ formData.tarifaCFE }}</span></div>
                <div class="info-item"><label>Dirección:</label><span>{{ formData.direccion }}</span></div>
                <div class="info-item"><label>Número de servicio:</label><span>{{ formData.numeroServicio }}</span>
                </div>
                <div class="info-item"><label>KWh/mes Promedio:</label><span>{{ averageKwh.toFixed(2) }} kWh</span>
                </div>
                <div class="info-item"><label>Monto mensual:</label><span>{{ formatMoney(averagePago) }}</span></div>
            </div>

            <div class="savings-card">
                <h4>Con paneles</h4>
                <div class="savings-item-inline">
                    <div class="savings-item">
                        <label>Nuevo pago (Estimado)</label>
                        <span>{{ formatMoney(nuevoPagoMensual) }}</span>
                    </div>
                    <div class="savings-item">
                        <label>Ahorro mensual</label>
                        <span class="text-green">{{ formatMoney(ahorroMensual) }}</span>
                    </div>
                </div>
            </div>

            <div class="info-card roi-card">
                <h4>ROI Flujos acumulados</h4>
                <label>Recuperación de inversión</label>
                <span>{{ tirRoi.roiYears }} años {{ tirRoi.roiMonths }} meses</span>
            </div>
        </div>

        <div class="info-card total-cost-card" style="grid-column: 1 / -1; margin-bottom: 25px;">
            <h4>Gasto total a 25 años</h4>
            <div class="total-cost-grid">
                <div>
                    <label>Sin paneles</label>
                    <span>{{ formatMoney(totalCost25Years.withoutPanels) }}</span>
                </div>
                <div>
                    <label>Con paneles</label>
                    <span>{{ formatMoney(totalCost25Years.withPanels) }}</span>
                </div>
                <div>
                    <label>Ahorro</label>
                    <span class="text-green">{{ formatMoney(totalCost25Years.savings) }}</span>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    name: 'GridMetricas',
    props: {
        formData: { type: Object, required: true },
        environmentalBenefit: { type: Object, default: () => ({}) },
        tirRoi: { type: Object, default: () => ({}) },
        totalCost25Years: { type: Object, default: () => ({}) },
        averagePago: { type: Number, default: 0 },
        averageKwh: { type: Number, default: 0 },
        roiDetail: { type: Array, default: () => [] }
    },
    computed: {
        pagoMinimoCFE() {
            const precios = this.formData.precios_cfe || {};
            const tarifa = (this.formData.tarifaCFE || '').toUpperCase();

            if (tarifa.includes('PDBT')) return precios.PDBT?.CARGO_FIJO || 78.00;
            if (tarifa.includes('GDMTO')) return precios.GDMTO?.CARGO_FIJO || 474.54;
            if (tarifa.includes('GDMTH')) return precios.GDMTH?.CARGO_FIJO || 777.67;

            return 0;
        },
        nuevoPagoMensual() {
             return this.formData.nuevoPagoMensualVisual * 1.16;
             
        },

        ahorroMensual() {
            return this.formData.ahorroMensualVisual;
        }
    },
    methods: {
        formatMoney(val) {
            return (val !== undefined && val !== null)
                ? Number(val).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
                : '$0.00';
        }
    }
}
</script>

<style scoped>
.confirmation-main-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 25px;
    align-items: start;
}

.grid-col {
    display: flex;
    flex-direction: column;
    gap: 25px;
}

.info-card,
.savings-card {
    background-color: var(--color-fondo-claro, #f8fafc);
    border-radius: 12px;
    padding: 25px;
    border: 1px solid var(--color-borde, #e2e8f0);
}

.info-card h4,
.savings-card h4 {
    font-size: 16px;
    font-weight: 600;
    margin: 0 0 20px 0;
    padding-bottom: 15px;
    border-bottom: 1px solid #e2e8f0;
}

.info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    padding: 10px 0;
    border-bottom: 1px solid #e2e8f0;
}

.info-item:last-child {
    border-bottom: none;
}

.info-item label {
    color: #718096;
    font-weight: 500;
}

.info-item span {
    font-weight: 500;
    text-align: right;
}

.savings-item label {
    display: block;
    font-size: 12px;
    color: #718096;
    margin-bottom: 5px;
}

.savings-item span {
    font-size: 22px;
    font-weight: 600;
}

.savings-item-inline {
    display: flex;
    gap: 30px;
}

.text-green {
    color: var(--color-exito, #48bb78);
}

.total-cost-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    text-align: center;
}

.total-cost-grid div {
    display: flex;
    flex-direction: column;
    padding: 15px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background-color: #fff;
}

.total-cost-grid label {
    font-size: 12px;
    color: #718096;
    margin-bottom: 5px;
}

.total-cost-grid span {
    font-size: 16px;
    font-weight: 600;
}

.tir-card,
.roi-card {
    text-align: center;
}

.tir-card span,
.roi-card span {
    font-size: 28px;
    font-weight: 700;
    display: block;
    margin-top: 10px;
}

.environmental-item {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #4a5568;
    margin-bottom: 5px;
}

.environmental-item i {
    margin-right: 10px;
    width: 24px;
    text-align: center;
}

.icon-cloud::before {
    content: "☁️";
}

.icon-tree::before {
    content: "🌳";
}

.icon-car::before {
    content: "🚗";
}

@media (max-width: 768px) {
    .confirmation-main-grid {
        grid-template-columns: 1fr;
    }

    .savings-item-inline {
        flex-direction: column;
        gap: 15px;
    }

    .total-cost-grid {
        grid-template-columns: 1fr;
    }
}
</style>